import { Enemy } from "../Enemy";
import { Game } from "../Game";
import { IBehaviour } from "./IBehaviour";
import { Geom } from "../Geom";
import { Timer } from "../Timer";
import { PointData } from "pixi.js";


const walking = { duration: 2000, speed: 0.3, color: { r: 0, g: 0, b: 0 } };
const telegraphing = { duration: 500, speed: 0, color: { r: 255, g: 255, b: 0 } };
const charging = { duration: 800, speed: 2, color: { r: 255, g: 0, b: 0 } };
const damaging = { duration: 800, speed: 2, color: { r: 255, g: 255, b: 255 } };


export class Grappler implements IBehaviour {
	private state = walking;
	private timer: Timer = new Timer();
	private chargeAngle: number = 0;
	private angle: number = 0;
	private elapsed: number = 0;
	private teleVel: number = 0;

	public tick(deltaMS: number, enemy: Enemy, game: Game): void {
		this.timer.tick(deltaMS);
		this.elapsed += deltaMS;

		if (this.state == charging || this.state == damaging) {
			Geom.moveInDirection(enemy, this.chargeAngle, this.state.speed * enemy.speed * deltaMS);
		} else if (this.state == walking) {
			Geom.moveInDirection(enemy, this.angle, this.state.speed * enemy.speed * deltaMS);
		}
		enemy.hitbox.color = this.state.color;
		if (this.state == charging && Geom.distance(enemy, game.player) < game.player.size + enemy.size) {
			game.player.takeDamage(game, enemy.damage);
			this.state = damaging;
			this.timer.reset()
		}
		if (this.state == telegraphing) {
			this.chargeAngle = Geom.angle(enemy, game.player);
			this.teleVel -= 0.1;
			enemy.x -= Math.cos(this.chargeAngle) * this.teleVel;
			enemy.y -= Math.sin(this.chargeAngle) * this.teleVel;
		}
		if (this.timer.elapsed > this.state.duration) {
			if (this.state == walking) {
				this.state = telegraphing;
				this.teleVel = 3;
			} else if (this.state == telegraphing) {
				this.chargeAngle = Geom.angle(enemy, game.player);
				this.state = charging;
			} else if (this.state == charging) {
				this.state = walking;
				this.angle = Math.random() * 2 * Math.PI;
			} else if (this.state == damaging) {
				this.state = walking;
				this.angle = Math.random() * 2 * Math.PI;
			}
			this.timer.reset();
		}
	}
}
